import isNumber from 'lodash/isNumber';
import round from 'lodash/round';
import { ComputeResourceType } from '@cast/shared-types';

import { computeResourceUnitsMap } from 'constants/maps';

import {
  PreparedWorkload,
  ResourceMetrics,
} from 'features/workload-optimization';
import { Typography, Stack, tokens } from '@cast/design-system';

type OriginalRequestsMetricsRowProps = {
  metrics: ResourceMetrics;
  unit: ComputeResourceType;
};

const OriginalRequestsMetricsRow = ({
  metrics,
  unit,
}: OriginalRequestsMetricsRowProps) => {
  const { originalRequests: _originalRequests } = metrics;
  const originalRequests = _originalRequests
    ? round(_originalRequests, 3)
    : undefined;

  return (
    <Stack direction="row" gap={6} alignItems="center" data-testid={unit}>
      <Typography
        variant="P12R"
        color={!isNumber(originalRequests) ? 'grey.400' : 'grey.900'}
        data-testid="original-req"
      >
        {originalRequests ? originalRequests : 'N/A'}
      </Typography>
      <Typography variant="P12R" color={tokens.theme.fg.structural.secondary}>
        {computeResourceUnitsMap[unit]}
      </Typography>
    </Stack>
  );
};

export const OriginalRequestsCell = ({ cpu, memory }: PreparedWorkload) => {
  return (
    <Stack>
      <OriginalRequestsMetricsRow
        metrics={cpu}
        unit={ComputeResourceType.CPU}
      />
      <OriginalRequestsMetricsRow
        metrics={memory}
        unit={ComputeResourceType.MEMORY}
      />
    </Stack>
  );
};
